import {
  EventsIcon,
  FileDeleteIcon,
  IconSize,
  OrganizationIcon,
  ResourcesIcon,
  UserIcon,
} from "@shared/components/ui/Icon";
import { User } from "@shared/types/user";
import React from "react";
import { Link, useNavigate } from "react-router-dom";

export interface MetricItemProps {
  icon?: React.ReactNode;
  value: string | number;
  label: string;
  link?: string;
}

export interface MetricsSectionProps {
  metrics: MetricItemProps[];
  user?: User;
}

const metricItems = {
  People: <UserIcon size={IconSize.MEDIUM} color="text-gray-800" />,
  Organizations: (
    <OrganizationIcon size={IconSize.MEDIUM} color="text-gray-800" />
  ),
  Resources: <ResourcesIcon size={IconSize.MEDIUM} color="text-gray-800" />,
  Events: <EventsIcon size={IconSize.MEDIUM} color="text-gray-800" />,
};

const MetricItem: React.FC<MetricItemProps> = ({
  icon,
  value,
  label,
  link,
}) => {
  return (
    <div className="flex items-center">
      <div className="mr-3 p-4 rounded-full bg-[#B3E2FF] dark:bg-[#B3E2FF]">
        {metricItems[label] || (
          <FileDeleteIcon size={IconSize.MEDIUM} color="text-white" />
        )}
      </div>
      <div>
        <div className="text-3xl font-bold text-gray-800 dark:text-gray-100">
          {value}
        </div>
        <div className="text-xs text-gray-500 dark:text-gray-400">{label}</div>
      </div>
    </div>
  );
};

const MetricsSection: React.FC<MetricsSectionProps> = ({ metrics, user }) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col col-span-full bg-white dark:bg-gray-800 shadow-sm rounded-xl">
      <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60">
        <h2 className="font-madefor font-bold text-gray-800 dark:text-gray-100">
          Hi {user?.profile?.name}
        </h2>
      </header>
      <div className="px-5 py-6">
        <div className="md:flex md:justify-between md:items-center">
          {/* Right side - Metrics */}
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4 w-full">
            {metrics.map((metric, index) => (
              <Link to={metric.link} key={index}>
                <MetricItem
                  icon={metric.icon}
                  value={metric.value}
                  label={metric.label}
                />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetricsSection;
